import React from 'react';
import ReactDOM from 'react-dom';
import GoogleMap from 'google-map-react';


class ChangePositionView extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = new Object();
      this.startPos = this.props.startPos.lng == 0 && this.props.startPos.lat == 0 ?
      { lng:12.695131, lat:55.908899 }  : this.props.startPos;


      this.state.newPos = this.startPos;
   }

   componentDidMount()
   {
     
   }
   render()
   {

    var containerStyle=
      {
         position:"relative",
         width:"700px",
         //height:"600px",
         padding:10,
         backgroundColor:"#DDDDDD"
      }

      var mapContainerStyle =
      {
        position:"relative",
        width:600,
        //backgroundColor:"red",
        height:600,
      }

      var mapStyle =
      {
        //position:"absolute",
         
      }

      var bottomBarStyle =
      {
         //position:"relative",
         display:"block",
         //bottom:0,
         //backgroundColor:"green",
      }

      var crosshairStyle=
      {
        left:(300-10),
        top:(300-10),
        position:"absolute",
        zIndex:3,
        //backgroundColor:"green",
        width:20,
        height:20,
      }
     var clickedSave = function()
     {
      this.props.changePositionCallback(this.state.newPos);
     }.bind(this);

     var clickedCancel = function()
     {
        this.props.changePositionCallback(null);
     }.bind(this);

     var onChangeCenter = function(changed)
     {
        this.setState({newPos:changed.center});
     }.bind(this);

    var options = {
      overviewMapControl: false,
      streetViewControl: false,
      rotateControl: true,
      mapTypeControl: true,
      mapTypeId:"satellite",
      // disable poi
      //styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
      //minZoom: DEFAULT_MIN_ZOOM, // dynamically recalculted if possible during init
      }
      return (
         <div style={containerStyle}>
          <div style={mapContainerStyle}
          onMouseDown={()=>this.setState({mouseDown:true})} onMouseUp={()=>this.setState({mouseDown:false})}>
              {<GoogleMap options={options} bootstrapURLKeys={{key:"AIzaSyA3jDZgzpuoyAJ41dc9Nqs6D2lNjw3Tv5w"}}
                defaultCenter={this.startPos} style={mapStyle}
                defaultZoom={15} onChange={onChangeCenter}>
                <PositionMarker lat={this.startPos.lat} lng={this.startPos.lng} color="grey"/>
                <PositionMarker lat={this.state.newPos.lat} lng={this.state.newPos.lng} color="red"/>
              </GoogleMap>}
              {this.state.mouseDown ?
              <svg style={crosshairStyle} 
                height="20" width="20">
                <circle r="10" cx="10" cy="10" fillOpacity="0" strokeWidth="3" stroke="red"/>
              </svg> : null}
            </div>
            <div style={{height:20}}/> 
            <div style={bottomBarStyle}>
              <button style={{float:'left', fontSize:24}} onClick={clickedSave}>save</button>
              <button style={{float:'right', fontSize:24}} onClick={clickedCancel}>cancel</button>
              <div style={{clear:'both'}}></div>
            </div>
          </div>
      );
    }
}
export default ChangePositionView ;

const doubleNumberShape = React.PropTypes.shape({
    lat: React.PropTypes.number,
    lng: React.PropTypes.number
  });

ChangePositionView.propTypes = {
  changePositionCallback: React.PropTypes.func.isRequired,
  startPos: doubleNumberShape.isRequired,
};

var PositionMarker = function(props)
{
  var markerStyle =
  {
    stroke:props.color,
    strokeWidth: 2,
  }
  return (
      <svg style={{left:-15, top:-15, position:"absolute"}} 
        height="30" width="30">
        <line x1="0" y1="0" x2="30" y2="30" style={markerStyle} />
        <line x1="30" y1="0" x2="0" y2="30" style={markerStyle} />
      </svg>
    );
}



// WEBPACK FOOTER //
// ./js/ChangePositionView.jsx